var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a-spin',{attrs:{"tip":_vm.spinningMessage,"spinning":_vm.spinning}},[_c('Header',{ref:"header"}),_c('Content',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }